import BaseModel from '../core/BaseModel';
import VehicleCategoryModel from '@/models/VehicleCategoryModel';

export default class AvailableForRentModel extends BaseModel {

    constructor() {
        super({
                name: "available_for_rent",
                tableName: 'available_for_rent',
                label: "Available For Rent"
            },


            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                avatar: {
                    name: "avatar",
                    label: "Cover",
                    custom: 'image',
                    type: "Computed",
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    width: 3,
                    class : 'left'
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Post ID',
                    filter: { type: 'input', match: 'contains' },
                    width: 15,
                    class : 'left'
                },
                vehicle_category_id: {
                    name: "vehicle_category_id",
                    label: "Vehicle category",
                    type: "Computed",
                    models: new VehicleCategoryModel(),
                    filter: { type: 'input', match: 'contains' },
                    class: "left",
                    width: 35,
                },
                
                rent: {
                    name: "rent",
                    label: "Rental",
                    type: "Computed",
                    computed: (data) => {
                        data.rent ='' ;
                    },
                    class : 'left',
                    width : 10,
                },
                new: {
                    name: "new",
                    label: "New",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class : 'left',
                    width : 2,
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class : 'left',
                    width : 2,
                },
                updated_by: {
                    name: "updated_by",
                    label: "Updated by",
                    type: "Computed",
                    computed: (data) => {
                        data.updated_by = '';
                    },
                    class: "left",
                    width : 20,
                },
                updated_at: {
                    name: 'updated_at',
                    type: "DateTime",
                    label: 'Updated date',
                    width : 20,
                    class: "left",
                },
              
                deleted: {
                    name: "deleted",
                    label: "Deleted",
                    type: "Boolean",
                    display: false 
                },
                auto_in_number: {
                    name: "auto_in_number",
                    label: "Auto Number",
                    type: "Integer",
                    filter: { type: 'input', match: 'contains' },
                    display: false 
                },
                slug: { 
                    name: "slug",
                    label: "Slug",
                    type: "String",
                    filter: { type: 'input', match: 'contains' },
                    display: false 
                },
         
                created_at: {
                    name: 'created_at',
                    type: "DateTime",
                    label: 'Created at',
                    display: false 
                },
                detail_get: {
                    refs:  ' alt  obj_vehicle_category { id name bond_fee}  update_user { id fullname } ',
                    display: false
                },
                detail_get1: {
                    refs:  'id description ',
                    display: false
                },
            }
        )
    }
}
